const state = {
  pendingOrgSwitch: null,
};

const getters = {
  pendingOrgSwitch: state => state.pendingOrgSwitch,
};

const mutations = {
  SET_PENDING_ORG_SWITCH(state, orgId) {
    state.pendingOrgSwitch = orgId;
  },
  CLEAR_PENDING_ORG_SWITCH(state) {
    state.pendingOrgSwitch = null;
  },
};

const actions = {
  requestOrgSwitch({ commit }, orgId) {
    commit('SET_PENDING_ORG_SWITCH', orgId);
  },
  confirmOrgSwitch({ commit }) {
    commit('CLEAR_PENDING_ORG_SWITCH');
  },
  cancelOrgSwitch({ commit }) {
    commit('CLEAR_PENDING_ORG_SWITCH');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
